"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOKENS = void 0;
var TOKENS = {
  DEFAULT_IMAGE_WIDTH: '100%',
  DEFAULT_IMAGE_PRODUCT_CARD: '100px',
  TITLE: {
    SIZE: 'default',
    COLOR: 'neutral'
  }
};
exports.TOKENS = TOKENS;